import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DigisubservicesService } from '../services/digisubservices.service';
import { PrintOptions } from 'ngx-print';

@Component({
  selector: 'app-expenseledger',
  templateUrl: './expenseledger.component.html',
  styleUrls: ['./expenseledger.component.scss']
})
export class ExpenseledgerComponent {
  printOptions: PrintOptions = {
    printSectionId: 'print-section',
    printTitle: 'My Print Title',
    useExistingCss: true,
    bodyClass: 'print-body',
    openNewTab: true,
    previewOnly: false,
    closeWindow: false,
    printDelay: 500
  };

  currentDate = new Date();
  startDate: any;
  endDate: any;
  startDate1: any;
  endDate1: any;
  mainexp: any;
  source: any;
  subexp: string;
  allvoucherdata: any[] = [];
  allvoucherdata1: any[] = [];
  credittotal = 0;
  debittotal = 0;
  credittotal1 = 0;
  debittotal1 = 0;
  openingNew: any
  expname: string = '';
  cr_opening_bal: number = 0;
  dr_opening_bal: number = 0;
  cr_opening_bal1: number = 0;
  dr_opening_bal1: number = 0;
  specialExpIds: string[] = [];
  calls: string[] = ['30', '38', '39', '60', '73', '74', '75', '85', '61', '88', '90', '93', '97', '98', '119', '120', '121', '122', '130'];
  calls1: string[] = ['33', '62', '64', '67', '70', '82', '86'];

  constructor(
    private datePipe: DatePipe,
    private dialogRef: MatDialogRef<ExpenseledgerComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private service: DigisubservicesService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {

    (async () => {
      await this.fetchMoreCalls(); // wait for dynamic ids to be added to `calls`

      this.startDate = this.data['startDate'];
      this.endDate = this.data['endDate'];
      this.mainexp = this.data['mainexp'].id;
      this.source = this.data['mainexp'].source;
      this.subexp = this.data['subexp'];

      console.log("exp_name_test" + this.mainexp);

      debugger

      if (this.startDate !== '2024-04-01') {
        this.startDate1 = '2024-04-01';

        const start = new Date(this.startDate);
        const dayBefore = new Date(start.setDate(start.getDate() - 1));

        const year = dayBefore.getFullYear();
        const month = String(dayBefore.getMonth() + 1).padStart(2, '0');
        const date = String(dayBefore.getDate()).padStart(2, '0');

        this.endDate1 = `${year}-${month}-${date}`;

        if (this.calls1.includes(this.mainexp)) {
          this.service.getAllDebitVocher({
            exp_id: this.mainexp,
            subexp_id: this.subexp,
            startdate: this.startDate1,
            enddate: this.endDate1,
          }).subscribe((drData: any[]) => {
            this.allvoucherdata1 = [...this.allvoucherdata1, ...drData];
            this.dr_opening_bal1 = Number(drData[0]?.opening_bal_dr || 0);

            this.service.getAllCreditVocher({
              exp_id: this.mainexp,
              subexp_id: this.subexp,
              startdate: this.startDate1,
              enddate: this.endDate1,
            }).subscribe((crData: any[]) => {
              this.allvoucherdata1 = [...this.allvoucherdata1, ...crData];
              this.cr_opening_bal1 = Number(crData[0]?.opening_bal_cr || 0);

              // Now calculate totals after both API calls are done
              this.credittotal1 = 0;
              this.debittotal1 = 0;

              this.allvoucherdata1.forEach(element => {
                const amt = Number(element.exp_amt || 0);
                if (element.voucher === 'cr') {
                  this.credittotal1 -= amt;
                } else if (element.voucher === 'dr') {
                  this.debittotal1 -= amt;
                }
              });

              this.openingNew =
                (Number(this.cr_opening_bal1) - Number(this.credittotal1)) +
                (Number(this.dr_opening_bal1) - Number(this.debittotal1));

              // Now fetch the main data
              this.getDebitVoucher();
            });
          });

        } else if (this.calls.includes(this.mainexp)) {
          this.service.getAllSubscriptiontype({
            exp_id: this.mainexp,
            subexp_id: this.subexp,
            source: this.source,
            startdate: this.startDate1,
            enddate: this.endDate1,
          }).subscribe((data: any[]) => {
            this.allvoucherdata1 = [...this.allvoucherdata1, ...data];
            this.dr_opening_bal1 = 0;
            this.cr_opening_bal1 = 0;

            // Perform calculations
            this.credittotal1 = 0;
            this.debittotal1 = 0;

            this.allvoucherdata1.forEach(element => {
              const amt = Number(element.exp_amt || 0);
              if (element.voucher === 'cr') {
                this.credittotal1 -= amt;
              } else if (element.voucher === 'dr') {
                this.debittotal1 -= amt;
              }
            });

            this.openingNew = this.credittotal1 + this.debittotal1;

            this.subscriptiontype(); // Continue with main flow
          });

        } else {
          // Default fallback
          this.service.getAllDebitVocher({
            exp_id: this.mainexp,
            subexp_id: this.subexp,
            startdate: this.startDate1,
            enddate: this.endDate1,
          }).subscribe((drData: any[]) => {
            this.allvoucherdata1 = [...this.allvoucherdata1, ...drData];
            this.dr_opening_bal1 = Number(drData[0]?.opening_bal_dr || 0);

            this.service.getAllCreditVocher({
              exp_id: this.mainexp,
              subexp_id: this.subexp,
              startdate: this.startDate1,
              enddate: this.endDate1,
            }).subscribe((crData: any[]) => {
              this.allvoucherdata1 = [...this.allvoucherdata1, ...crData];
              this.cr_opening_bal1 = Number(crData[0]?.opening_bal_cr || 0);

              this.credittotal1 = 0;
              this.debittotal1 = 0;

              this.allvoucherdata1.forEach(element => {
                const amt = Number(element.exp_amt || 0);
                if (element.voucher === 'cr') {
                  this.credittotal1 -= amt;
                } else if (element.voucher === 'dr') {
                  this.debittotal1 -= amt;
                }
              });

              this.openingNew =
                (Number(this.cr_opening_bal1) - Number(this.credittotal1)) +
                (Number(this.dr_opening_bal1) - Number(this.debittotal1));

              this.getDebitVoucher();
            });
          });
        }
      } else {
        if (this.calls1.includes(this.mainexp)) {
          this.getDebitVoucher();
        } else if (this.calls.includes(this.mainexp)) {
          this.subscriptiontype();
        } else {
          this.getDebitVoucher();
        }
      }

    })();

  }

  // fetchMoreCalls() {
  //   this.service.getMoreCallIds().subscribe((data: { id: string }[]) => {
  //     const newIds = data.map(item => item.id);
  //     this.calls = Array.from(new Set([...this.calls, ...newIds]));
  //   });
  // }

  fetchMoreCalls(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.service.getMoreCallIds().subscribe({
        next: (response: { id: string }[]) => {
          const newIds = response.map(item => item.id);
          this.calls = Array.from(new Set([...this.calls, ...newIds]));
          console.log('Merged calls:', this.calls); // Debugging log
          resolve(); // Resolve when done
        },
        error: (err) => {
          console.error('Error fetching call IDs', err);
          reject(err); // Reject on error
        }
      });
    });
  }


  getFormattedDate(): string {
    return this.datePipe.transform(this.currentDate, 'dd-MM-yyyy') || '';
  }

  getDebitVoucher() {
    const payload = {
      exp_id: this.mainexp,
      subexp_id: this.subexp,
      startdate: this.startDate,
      enddate: this.endDate,
    };
    this.service.getAllDebitVocher(payload).subscribe((data: any[]) => {
      this.allvoucherdata = [...this.allvoucherdata, ...data];
      this.dr_opening_bal = Number(data[0]?.opening_bal_dr || 0);
      this.getCreditVoucher();
    });
  }

  getDebitVoucher1() {
    const payload = {
      exp_id: this.mainexp,
      subexp_id: this.subexp,
      startdate: this.startDate1,
      enddate: this.endDate1,
    };
    debugger
    this.service.getAllDebitVocher(payload).subscribe((data: any[]) => {
      debugger
      this.allvoucherdata1 = [...this.allvoucherdata1, ...data];
      this.dr_opening_bal1 = Number(data[0]?.opening_bal_dr || 0);
      this.getCreditVoucher1();
    });
  }

  getCreditVoucher() {
    const payload = {
      exp_id: this.mainexp,
      subexp_id: this.subexp,
      startdate: this.startDate,
      enddate: this.endDate,
    };
    this.service.getAllCreditVocher(payload).subscribe((data: any[]) => {
      this.allvoucherdata = [...this.allvoucherdata, ...data];
      this.cr_opening_bal = Number(data[0]?.opening_bal_cr || 0);
      if (this.calls1.includes(this.mainexp)) {
        this.subscriptiontype();
      } else {
        this.calculationOfNgOnInitMethod();
      }
    });
  }

  getCreditVoucher1() {
    const payload = {
      exp_id: this.mainexp,
      subexp_id: this.subexp,
      startdate: this.startDate1,
      enddate: this.endDate1,
    };
    this.service.getAllCreditVocher(payload).subscribe((data: any[]) => {
      this.allvoucherdata1 = [...this.allvoucherdata1, ...data];
      this.cr_opening_bal1 = Number(data[0]?.opening_bal_cr || 0);
      if (this.calls1.includes(this.mainexp)) {
        this.subscriptiontype1();
      }
    });
  }

  subscriptiontype() {
    const payload = {
      exp_id: this.mainexp,
      subexp_id: this.subexp,
      source: this.source,
      startdate: this.startDate,
      enddate: this.endDate,
    };
    this.service.getAllSubscriptiontype(payload).subscribe((data: any[]) => {
      this.allvoucherdata = [...this.allvoucherdata, ...data];
      this.dr_opening_bal = 0;
      this.cr_opening_bal = 0;
      this.calculationOfNgOnInitMethod();
    });
  }

  subscriptiontype1() {
    const payload = {
      exp_id: this.mainexp,
      subexp_id: this.subexp,
      startdate: this.startDate1,
      enddate: this.endDate1,
    };
    this.service.getAllSubscriptiontype(payload).subscribe((data: any[]) => {
      this.allvoucherdata1 = [...this.allvoucherdata1, ...data];
      this.dr_opening_bal1 = 0;
      this.cr_opening_bal1 = 0;
    });
  }

  calculationOfNgOnInitMethod() {
    this.calculation();

    debugger

    // Sort by voucher_date
    this.allvoucherdata.sort((a, b) =>
      new Date(a.voucher_date).getTime() - new Date(b.voucher_date).getTime()
    );

    // Set expname from first entry
    this.expname = this.allvoucherdata[0]?.exp_name || '';

    // Handle opening balances
    if (this.startDate !== '2024-04-01') {
      debugger
      if (this.cr_opening_bal === 0) {
        this.cr_opening_bal = 0;
        this.dr_opening_bal = this.openingNew;
      } else {
        this.cr_opening_bal = this.openingNew;
        this.dr_opening_bal = 0;
      }
    } else {
      this.cr_opening_bal = Number(this.cr_opening_bal || 0);
      this.dr_opening_bal = Number(this.dr_opening_bal || 0);
    }

    // Calculate running total
    this.allvoucherdata.forEach((element, index) => {
      const prevTotal = index > 0 ? this.allvoucherdata[index - 1].total : 0;
      const expAmt = Number(element.exp_amt || 0);
      let total = 0;

      debugger

      if (this.startDate !== '2024-04-01') {
        if (index === 0) {
          total = expAmt;
          if (element.voucher === 'cr') {
            total = this.specialExpIds.includes(this.mainexp)
              ? this.openingNew - expAmt
              : this.openingNew + expAmt;
          } else if (element.voucher === 'dr') {
            total = this.specialExpIds.includes(this.mainexp)
              ? this.openingNew + expAmt
              : this.openingNew + expAmt;
          }
        } else {
          if (element.voucher === 'cr') {
            total = prevTotal + expAmt;
          } else {
            total = prevTotal + expAmt;
          }
        }
      } else {
        if (index === 0) {
          total = expAmt;
          if (element.voucher === 'cr') {
            if (this.cr_opening_bal != 0) {
              total = this.cr_opening_bal + expAmt;
            } else {
              total = this.dr_opening_bal + expAmt;
            }
          } else if (element.voucher === 'dr') {
            if (this.dr_opening_bal != 0) {
              total = this.dr_opening_bal + expAmt;
            } else {
              total = this.cr_opening_bal + expAmt;
            }
          }
        } else {
          if (element.voucher === 'cr') {
            total = prevTotal + expAmt;
          } else {
            total = prevTotal + expAmt;
          }
        }
      }

      element.total = total;
    });

    this.cdr.detectChanges();
  }

  calculation(): void {
    this.credittotal = 0;
    this.debittotal = 0;

    this.allvoucherdata.forEach(element => {
      const amt = Number(element.exp_amt || 0);
      if (element.voucher === 'cr') {
        this.credittotal -= amt;
      } else if (element.voucher === 'dr') {
        this.debittotal -= amt;
      }
    });
  }

  closeexp(): void {
    this.dialogRef.close();
    this.allvoucherdata = [];
    this.expname = '';
    this.dr_opening_bal = 0;
    this.cr_opening_bal = 0;
    this.debittotal = 0;
    this.credittotal = 0;
  }

}